import gsap from 'gsap'

import { batchRevealAnimation } from './shared'
import { Animation } from '@/types'

export const archiveGridRevealAnimation = ({
  node,
  reverse,
  mobile,
  context
}: Animation) => {
  if (mobile) return

  const selector = context?.selector || gsap.utils.selector(node)

  const cards = selector('[data-motion-card]')

  batchRevealAnimation({
    targets: cards,
    reverse,
    stagger: {
      amount: 0.2
    }
  })
}
